var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { colord } from 'colord';
import { Colors, ZapCardSection as ZapCardSectionZDS, } from '@zapier/design-system';
import { Section } from '../Section';
import { Builder } from '@builder.io/react';
import useSWR from 'swr';
import { fetchGuidedRecipe } from '../../data';
import { useTracking } from '../../tracking';
export function ZapCardSection(props) {
    const { items } = useUnregisteredProps(props);
    return (_jsx(Section, Object.assign({ background: props.background, contentWidth: "custom" }, { children: _jsx(ZapCards, { items: items || [], layout: props.layout }) })));
}
function ZapCards({ items, layout }) {
    const { emitUserInteractionEvent } = useTracking();
    const zapCardItems = items.map((item, index) => (Object.assign(Object.assign({}, item), { services: item.services || [], color: item.color
            ? colord(item.color).toHex()
            : Colors.white, key: `zap_card_${index}`, onClick: () => {
            emitUserInteractionEvent({
                interaction_raw_text: item.title,
                destination_href: item.href,
                option_selected: 'zap_card_link',
                event_action: 'click',
                interaction_name: 'call_to_action',
            });
        } })));
    return _jsx(ZapCardSectionZDS, { items: zapCardItems, layout: layout });
}
export const fetchZapTemplates = (items) => __awaiter(void 0, void 0, void 0, function* () {
    const templates = yield Promise.all((items || []).map((item) => __awaiter(void 0, void 0, void 0, function* () {
        if (!item.zapTemplateID)
            return item;
        const zapTemplate = yield fetchGuidedRecipe(item.zapTemplateID);
        if (zapTemplate)
            return Object.assign(Object.assign(Object.assign({}, item), zapTemplate), { 
                // Use the title/href from API if none was input by the Builder user.
                title: item.title || zapTemplate.title, href: item.href || zapTemplate.href, color: item.color || zapTemplate.color });
    })));
    return templates.filter(Boolean);
});
export const useUnregisteredProps = (props) => {
    const { data } = useSWR(`zap-templates/${JSON.stringify(props.items || [])}`, () => __awaiter(void 0, void 0, void 0, function* () {
        if (Builder.isEditing || Builder.isPreviewing) {
            try {
                return (yield fetchZapTemplates(props.items));
            }
            catch (e) {
                return props.items;
            }
        }
        return props.items;
    }));
    return Object.assign(Object.assign({}, props), { items: data });
};
export const ZapCardSectionAsyncProps = (props) => __awaiter(void 0, void 0, void 0, function* () {
    const zapTemplates = yield fetchZapTemplates((props === null || props === void 0 ? void 0 : props.items) || []);
    return Object.assign(Object.assign({}, props), { items: zapTemplates });
});
//# sourceMappingURL=ZapCardSection.js.map